import axios from 'axios';

import {callAPI} from './Base';

class Products { 
  
    constructor(){
        this.cache = {
            featuredCycles : null,
            categories: {
                'cycles' : '',
                'accessories' : '',
            }
        };
    }   

    getFeaturedCycles(callback, force = true){
        
        if( this.cache.featuredCycles && force) {
            callback(this.cache.featuredCycles)
            return;
        }

        axios.get( callAPI('GetFeaturedCycles') )
            .then( (response) => {

                this.cache.featuredCycles = response;				  
                callback(response);
           
            })
            .catch(function (error) {
                console.log(error); 
            });	 
        
    }


    getCatgories(type, callback, force = true){

        if( type === 'CYCLES' ) {
            if( this.cache.categories.cycles && force) {
                callback(this.cache.categories.cycles)
                return;
            }
        } else {
            if( this.cache.categories.accessories && force) {
                callback(this.cache.categories.accessories)
                return;
            }
        }

        axios.get( callAPI('GetCategories\\' + type) )
            .then( (response) => {
                if( type === 'CYCLES' ) {
                    this.cache.categories.cycles      = response;            
                } else {                   
                    this.cache.categories.accessories = response;            
                }
                callback(response);           
            })
            .catch(function (error) {
                console.log(error); 
            });  
        
    }

    getProduct(data, callback){
        axios.get( callAPI('GetProduct/' + data.productType + '/' + data.productURI) )
            .then( (response) => {			  
                callback(response);  

            })
            .catch(function (error) {
                console.log(error); 
            });	
    }

    getAllProducts(data, callback) {

        let fd = new FormData();

        for( let attr in data) {
            fd.append( attr, data[attr]);
        }

        axios({
            method: 'POST',
            url: callAPI('GetProduct/' + data.productType),
            data: fd,
        }).then(function( response ) {
            callback( response )
        });
    }
    
    
    
}

let prd = new Products();

export default prd;


// WEBPACK FOOTER //
// ./src/Core/Products.js